export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./eventsVideo.vue?vue&type=template&id=2aab9c46&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/eventsVideo.vue?vue&type=template&id=2aab9c46&
// module id = 1337
// module chunks = 0